
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectWizardPromoter1Selector.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/EntityBased/HintBox/HintBox"
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
class ProjectWizardPromoter1Selector extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    promoter1: MdsLax<InstanceType<typeof HintBox>>;

    protected afterSetData() {
        let data = this.sourceData as VAM2types.EvProject_PromoterEntity;
    }

    protected onDirtyChange(currentState: boolean) {

    }

    protected _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }

    private _onChanged_EvPromoter1(key: string, newValue: VAM2types.EvProject_PromoterEntity, oldValue: any) {

        //this.emit("promoter_1_ref_address");
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.setupHintboxes();

        this.addOnchanged("ref_address", lang.hitch(this, this._onChanged_EvPromoter1));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProjectWizardPromoter1Selector);